import type { FaireProductEntity } from "../../entity_types/product";

export const p_7wri7evhpd: FaireProductEntity = {
  token: "p_7wri7evhpd",
  type: "product",
  name: "Rose Knotted Gown",
  brandToken: "b_3pci2bfmjr",
  brandName: "Three Little Tots",
  imageUrl:
    "https://cdn.faire.com/fastly/795b146df0abd1406f302adc4e670116bbd58f06a5ec745485a5f3eb877c97a8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/22da62b1e3e6e1944f5547d2bff139d73a6c212e95161dc7fdd7d5dd11245e55.jpeg",
    "https://cdn.faire.com/fastly/a676ba469eefeb1adc58a15dd86f1ada1cf0e8a9480961591ab40b0f67fb0b30.jpeg",
    "https://cdn.faire.com/fastly/30e74a8755747b3ae1bd7c428b0e5b6d13978bbe2247325ac25d582a2ac55cb5.jpeg",
    "https://cdn.faire.com/fastly/616ab8054223fc396df0edc62f8eca878d831785282e567c9b777ebae45b0196.jpeg",
    "https://cdn.faire.com/fastly/7ceea71aeb45fa998b6c21c93296b2faf4e29d285e716d37fe486d28f71e5ca2.jpeg",
    "https://cdn.faire.com/fastly/2940b0f3eeb1737727d242d71ff1025c7a2642a2570a8df21a697f1c3f58d770.jpeg",
    "https://cdn.faire.com/fastly/e8f5868eae10a80aea49bae0ee2749bcafdcc77b294dd0680704d3c97e80a13c.jpeg",
    "https://cdn.faire.com/fastly/e1b635fb64ad9591357b1c38fa652f1141c80069aedb724d61c8297b3e5e6ce9.jpeg",
    "https://cdn.faire.com/fastly/1a4a049aa26f9816bde210472b821bcca505b0601f85419e30d1332d38f4bc26.jpeg",
    "https://cdn.faire.com/fastly/0de200435a0456392fa8ea68fe83e93c623b1e11544fbe00cdcc784d52077c82.jpeg",
    "https://cdn.faire.com/fastly/09dafeec218aaf2295ddd6d9f0a332cd09a5d162d9a2b55e1abf2c5859e764f5.jpeg",
    "https://cdn.faire.com/fastly/1e40c19b2ead280218c8508320392c660cf20a5a480dfbb5c22332aa5364384d.jpeg",
    "https://cdn.faire.com/fastly/1fe57d41d1892d0fc7a096654d09330e0fc1032e2523b575fb77ac0c58ca5fb4.jpeg",
    "https://cdn.faire.com/fastly/054dc08dd1931b5e58d706c4ef40a36dddf22017871fd8195b59f51582eb6ae0.jpeg",
    "https://cdn.faire.com/fastly/62d222f603bbea1156f82a5be7b36c7c9d9f25dce0578c3dec2022f3b3e8a190.jpeg",
    "https://cdn.faire.com/fastly/188169ce4773dedd6fccefa5eb8ce9af694a8095dfabe7a977ad48882d9190d7.jpeg",
    "https://cdn.faire.com/fastly/50c2fbce17998dde21da50740f18da801b7c6a77d194b5d5451ab10c6d8976dc.jpeg",
    "https://cdn.faire.com/fastly/a8de0a0996e1efc7634e6684de67cd48d5a006466978c5c4a6f8b6f883e7ee59.jpeg",
    "https://cdn.faire.com/fastly/d26994e525d69e50dd2405619c976f3cb41dbbc8410039681111a6c4c601e534.jpeg",
    "https://cdn.faire.com/fastly/5da74870525a3ef2193fdb7818632290be636d1634fd68a6ef2d2ec868060082.jpeg",
    "https://cdn.faire.com/fastly/aebe1ee2a665455d36a4ecda549980b9b3707ad862a89484f35469aac5f0ff46.jpeg",
    "https://cdn.faire.com/fastly/c4f004a6bde93332028aa47a0771847b877bf55a7591741c08938c69aa980644.jpeg",
    "https://cdn.faire.com/fastly/dac93fc938c38e586070732dd30da66cd4dd7a7dc541e123f425de86be835aa0.jpeg",
    "https://cdn.faire.com/fastly/2a5dfdb43d364ac32cad7e32dc6b59581295cdae615a82f713a482303ce1a0d4.jpeg",
    "https://cdn.faire.com/fastly/76b59797ddec88c65c6a31662a2e20f04f20f07acb8fda4a4ad35937b491b0ce.jpeg",
  ],
  priceDollars: 10.3,
  description:
    "These baby gowns are so soft you will never want your baby in anything else. Fabric designed to be soft, comfortable, and stretchy. The tie bottom allows for easy night-time diaper change. The pull down tabs on the shoulder makes it easy to dress and change. Newborn-3 month fits approx 5lbs-15lbs.",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:39.279Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
